import React, {useRef} from 'react'
import {useState} from 'react'
import {KTSVG, toAbsoluteUrl, useDebounce} from '../../../../_metronic/helpers'
import moment from 'moment-timezone'
import Papa from 'papaparse'
import {read, utils, writeFile, readFile} from 'xlsx'
import {processData} from '../../../Utils/_helpers'
import {useDispatch, useSelector} from 'react-redux'
import {globalSettingsTypes} from '../../../Utils/Constant/status'
import {
  useCreateSchedulerFileMutation,
  useCreateSummarySchedulerFileMutation,
  useGetSenderNumberQuery,
  useLazyGetSchedulerFileQuery,
} from '../../../../services/cellcast'
import {Form, useFormik} from 'formik'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import FileSchedulerReview from './FileSchedulerReview'
import FileSchedulerForm from './FileSchedulerForm'
import {stopLoading, startLoadding} from '../../../Redux/FrontEnd/Loading/LoadingSlice'

const FileSchedulerCreate = () => {
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const [getFileScheduler] = useLazyGetSchedulerFileQuery()

  const [step, setStep] = useState('form')

  const [file, setFile] = useState<any>()
  const [message, setMessage] = useState('')
  const [fields, setFields] = useState([])

  const [createSchedulerFile, {isLoading}] = useCreateSchedulerFileMutation()
  const [
    summarySchedulerFile,
    {isLoading: isLoadingSummarySchedulerFile, data: summaryScheduleData},
  ] = useCreateSummarySchedulerFileMutation()

  const {data: senderNumbers, isLoading: isLoadingSenderNumber} = useGetSenderNumberQuery(null)

  const formik = useFormik({
    initialValues: {
      template: '',
      name: '',
      description: '',
      timezone: {
        value: 'Australia/Sydney',
        label: 'AEST|UTC +10:00/+11:00',
      },
      sender: {value: '', label: ''},
      shortUrlPrefix: '',
    },
    onSubmit: async (values, {resetForm}) => {
      let finalData = new FormData()

      const senders = values.sender?.value?.split('_')

      const payload: any = {
        name: values.name,
        fileName: file?.name,
        sender: values.sender?.value !== '#SharedNum#' ? senders.at(1) : values.sender?.value,
        senderType: values.sender?.value !== '#SharedNum#' ? senders.at(0) : values.sender?.value,
        timezone: values.timezone.value,
        profile: 'common',
        description: values.description,
        message: message,
        file: file,
        shortUrlPrefix: values.shortUrlPrefix,
      }

      for (var key in payload) {
        finalData.append(key, payload[key])
      }

      dispatch(startLoadding())
      if (step === 'form') {
        await summarySchedulerFile(finalData)
          .unwrap()
          .then(async (res) => {
            toast.success(res.message)
            setStep('review')
          })
          .catch((e) => {
            toast.error(e.data.message)
          })
      } else {
        await createSchedulerFile(finalData)
          .unwrap()
          .then(async (res) => {
            toast.success(res.message)
            resetForm()
          })
          .catch((e) => {
            toast.error(e.data.message)
          })
        await getFileScheduler({
          sortField: 'createdAt',
          page: 1,
          sortOrder: 'descend',
        })
        navigate('/file-scheduler')
      }

      dispatch(stopLoading())
    },
  })

  const senderName =
    formik.values.sender.value === '#SharedNum#'
      ? formik.values.sender.value
      : formik.values.sender?.value?.split('_')?.at(1)

  const inputRef: any = useRef()

  const globalSettings = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )

  const handleChangeFile = (e: any) => {
    if (
      e[0]?.type == 'application/vnd.ms-excel' ||
      e[0]?.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      e[0].arrayBuffer().then((res: any) => {
        let data = new Uint8Array(res)
        let workbook = read(data, {type: 'array'})
        let worksheet = workbook.Sheets[workbook.SheetNames[0]]
        let fdata = utils.sheet_to_csv(worksheet, {rawNumbers: true})
        Papa.parse(fdata, {
          header: true,
          skipEmptyLines: false,
          complete: function (results: any) {
            const name = e.at(0)?.name?.split('.').at(0)

            setFile(e.at(0))
            setFields(results.meta.fields.slice(0, 3))
            formik.setFieldValue('name', name)
            formik.setFieldValue('description', name)
          },
        })
      })
    }
  }

  const handleClickLabel = (label: string) => {
    let startSubString = message?.slice(0, inputRef.current.selectionStart)
    let endSubString = message?.slice(inputRef.current.selectionEnd)
    let content = `${startSubString}{{${label}}}${endSubString}`

    setMessage(content)
  }

  const acceptedFileTypes = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
  }

  const hasCustomPriceSetting =
    globalSettings && globalSettings?.includes(globalSettingsTypes.SEND_WITH_CUSTOM_PRICE)
  const isSenderBusinessNameOrCustomNumber = false

  const isCustomPriceOrAlphaId = hasCustomPriceSetting
    ? isSenderBusinessNameOrCustomNumber
    : !globalSettings && isSenderBusinessNameOrCustomNumber

  const calculateMessage = processData(message ?? '', 0, isCustomPriceOrAlphaId)

  const canSubmit = file && message

  const renderStep = () => {
    switch (step) {
      case 'form':
        return (
          <FileSchedulerForm
            file={file}
            setFile={setFile}
            handleChangeFile={handleChangeFile}
            acceptedFileTypes={acceptedFileTypes}
            formik={formik}
            fields={fields}
            handleClickLabel={handleClickLabel}
            calculateMessage={calculateMessage}
            inputRef={inputRef}
            message={message}
            isLoading={isLoading}
            setMessage={setMessage}
            canSubmit={canSubmit}
            senderNumbers={senderNumbers}
          />
        )
      case 'review':
        return (
          <FileSchedulerReview
            data={summaryScheduleData?.data}
            handleSubmit={formik.handleSubmit}
            setStep={setStep}
          />
        )

      default:
        return (
          <FileSchedulerForm
            file={file}
            setFile={setFile}
            handleChangeFile={handleChangeFile}
            acceptedFileTypes={acceptedFileTypes}
            formik={formik}
            fields={fields}
            handleClickLabel={handleClickLabel}
            calculateMessage={calculateMessage}
            inputRef={inputRef}
            message={message}
            isLoading={isLoading}
            setMessage={setMessage}
            canSubmit={canSubmit}
            senderNumbers={senderNumbers}
          />
        )
    }
  }

  return (
    <div className='row'>
      {/* Render Content */}

      {renderStep()}

      {/* Message Preview */}
      <div className='col-md-4'>
        <div className='card p-8'>
          <div
            className='tab-pane fade show active'
            id='nav-home-quick'
            role='tabpanel'
            aria-labelledby='nav-home-tab'
          >
            <div
              className='tab-pane fade show active'
              id='nav-home-quick'
              role='tabpanel'
              aria-labelledby='nav-home-tab'
            >
              <div
                className='mobile-bg-wrapper grey-bg new_mobile'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                }}
              >
                <div className='mobile-inner'>
                  <div className='mobile-head'>
                    <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                      <KTSVG
                        className='svg-icon-8'
                        path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                      />
                      {senderName ? senderName : 'Sender ID'}
                    </strong>
                  </div>
                  <div className='mobile-body'>
                    <div className='message-box'>
                      <div className='time text-center'>Today {moment().format('LT')}</div>
                      <div className='message'>
                        <pre>{step !== 'form' ? summaryScheduleData?.data?.message : message}</pre>
                      </div>
                    </div>
                    <div className='send-msg'>
                      <input type='text' />
                      <a
                        href='#'
                        className='send_btn'
                        style={{
                          backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                        }}
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FileSchedulerCreate
